import { Component, input } from '@angular/core';
import { CurrentPackageComponent } from './components/current-package/current-package.component';
import { RecomendationPackageComponent } from './components/recomendation-package/recomendation-package.component';
import { PackagesOptionComponent } from './components/packages-option/packages-option.component';
import { ValidateHaloNumber } from '@data/domain/promo.entity';

@Component({
  selector: 'app-migrate-halo',
  standalone: true,
  imports: [CurrentPackageComponent, RecomendationPackageComponent, PackagesOptionComponent],
  templateUrl: './migrate-halo.component.html',
  styleUrl: './migrate-halo.component.scss'
})
export class MigrateHaloComponent {
  data = input<ValidateHaloNumber>({
    recommended: {
      name: '',
      desc: '',
      longdesc: '',
      productid: '',
      price: '',
      priceNumber: 0,
      bonus: [],
      terms: '',
      quota: '',
      validity: '',
      trxpackage: ''
    },
    id: '',
    businessproduct: '',
    is_bill: false,
    longdesc: '',
    name: '',
    product_type: '',
    price: '',
    priceNumber: 0,
    shortdesc: '',
    cust_msisdn: '',
    cust_name: '',
    cust_type: '',
    refresh_token: '',
    sso_token: '',
    reason: '',
    access_token_expired_at: 0,
    refresh_token_expired_at: 0,
    accessToken: '',
    msisdn: '',
    x_token: ''
  });
  msisdn = input<number>();
}
